import { render, staticRenderFns } from "./StocktakingProductDetail.vue?vue&type=template&id=4c17e25d&scoped=true&"
import script from "./StocktakingProductDetail.vue?vue&type=script&lang=js&"
export * from "./StocktakingProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c17e25d",
  null
  
)

export default component.exports